if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // Crosssell (optional): only for the normal add-to-cart submit
        const submitter = evt.submitter;
        const submitterName = submitter ? submitter.getAttribute('name') : null;
        const isAddToCartSubmit = !submitterName || submitterName === 'add';

        // Read crosssell checkboxes from the whole <product-form> element
        // (more robust if markup is moved outside <form> but still within the component)
        const crosssellChecked = isAddToCartSubmit ? Array.from(this.querySelectorAll('[data-crosssell-checkbox]:checked')) : [];
        const crosssellVariantIds = crosssellChecked.length
          ? crosssellChecked.map((el) => el.value).filter(Boolean).slice(0, 3)
          : [];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return response;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return response;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            // Stop button loading as soon as main add succeeded – drawer update continues in background
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

            // Crosssell: add selected variants after main add, using the same Dawn request style.
            if (crosssellVariantIds.length && this.cart) {
              const extraConfig = fetchConfig('javascript');
              extraConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete extraConfig.headers['Content-Type'];

              for (const variantId of crosssellVariantIds) {
                const extraData = new FormData();
                extraData.append('id', variantId);
                extraData.append('quantity', '1');
                extraData.append(
                  'sections',
                  this.cart.getSectionsToRender().map((section) => section.id)
                );
                extraData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);

                extraConfig.body = extraData;
                // eslint-disable-next-line no-await-in-loop
                const extraResponse = await fetch(`${routes.cart_add_url}`, extraConfig).then((r) => r.json());
                if (extraResponse && extraResponse.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: variantId,
                    errors: extraResponse.errors || extraResponse.description,
                    message: extraResponse.message,
                  });
                  this.handleErrorMessage(extraResponse.description);
                  this.error = true;
                  return extraResponse;
                }
                response = extraResponse;
              }
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            return response;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
